// extracted by mini-css-extract-plugin
export default {"searchBoxInput":"style_searchBoxInput__XKMap"};